import React from 'react'
import PageTitle from '../components/PageTitle'
import Link from '../components/Link'
import Layout from '../components/Layout'

const Resources = () => (
  <Layout>
    <PageTitle name="OIRA Resources" site="OIRA" />
    
    <h2>For Instructors</h2>
    <p><a href="https://ua.evaluationkit.com/" target="_blank" rel="noopener noreferrer">Student Opinions of Instruction</a></p>
    <p><a href="https://oira.ua.edu/new/resources/digitalmeasures.pdf" target="_blank" rel="noopener noreferrer">Instructions for Accessing SOI Reports in Digital Measures</a></p>
    <p><a href="https://oira.ua.edu/soi" target="_blank" rel="noopener noreferrer">SOI (Survey Dates, College SOI Representatives, and Survey Dashboard)</a></p>
    <br/>
    
    <h2>For Administrators</h2>
    <p><a href="https://oira.ua.edu/stat-profiles/view/majors" target="_blank" rel="noopener noreferrer">Statistical Profiles</a></p>
    <p><a href="https://syllabi.ua.edu/" target="_blank" rel="noopener noreferrer">Syllabus Archive (pre-Summer 2023)</a></p>
    {/*<p><a href="https://oira.ua.edu/admissions-data/" target="_blank" rel="noopener noreferrer">Admissions Data</a></p>
    <p><a href="https://oira.ua.edu/admissions-data-next/" target="_blank" rel="noopener noreferrer">Admissions Data - 2022</a></p>*/}

    <p><a href="https://oira.ua.edu/soi-archive/" target="_blank" rel="noopener noreferrer">SOI Reports Archive (Prior to Fall 2019)</a></p>

    <br/>

    <p>
      Direct any login questions or issues to{' '}
      <Link to="/contact">OIRA Contact</Link><Link to="https://reports.oira-ua.tech/site/">.</Link>
    </p>
    <hr />
    
    
  </Layout>
)

export default Resources
